<template>
  <div ref="parent" class="flex w-full">
    <div
      v-if="
        $route.name == 'WorkspaceItem'
          ? $store.state.auth.user.user_type == 'end_user'
            ? $store.state.data.workspaces.count > 1
            : true
          : false
      "
      :style="{
        color: $store.state.ui_options.theme.selected_item_color
      }"
      class="absolute flex space-x-2 cursor-pointer e top-24 right-4">
      <ArrowLeft
        class="w-5 h-5 mt-0.5"
        @click="
          $route.query.last_page ? $router.push(`/workspace/edit/${$route.params.wid}?tab=visible_pages`) : $router.push('/workspace')
        " />
      <div
        @click="
          $route.query.last_page ? $router.push(`/workspace/edit/${$route.params.wid}?tab=visible_pages`) : $router.push('/workspace')
        ">
        {{ $route.query.last_page == "setup" ? $t("Workspace Pages") : $t("Workspaces") }}
      </div>
    </div>
    <div class="relative flex w-full mt-2 ml-8 bg-white rounded-full min-w-max">
      <div class="relative w-full flex scroll-x-hidden scroll-y-hidden">
        <div class="w-full flex items-center justify-between overflow-x-hidden overflow-y-hidden rounded-full">
          <div class="flex items-center">
            <div
              v-for="(element, i) in visibleItems?.length ? visibleItems : visible_pages"
              :id="$utils.isUUID(element.id) || $route.name == 'WorkspaceItem' ? element.id : element.slug"
              ref="child"
              :key="element"
              class="cursor-pointer"
              @click="handleSelectTab(i)">
              <div class="relative outline-none ring-0" @mouseenter="hovered_tab_index = i" @mouseleave="hovered_tab_index = null">
                <div
                  :style="[selected_tab_index == i ? `color: ${$store.state.ui_options.theme.selected_item_color}` : '']"
                  :class="[selected_tab_index == i ? 'text-[15px] font-normal' : 'font-normal']"
                  class="relative inline-flex transition duration-300 ease-in-out rounded-sm cursor-pointer sm:text-lg text-common-grey focus:outline-none">
                  <div
                    class="flex items-center h-12 px-8 py-2 bg-white whitespace-nowrap"
                    :class="[i == visibleItems.length - 1 ? 'pr-10' : '', !i ? 'pl-8' : '']">
                    <component
                      :is="getIcon(element)"
                      :key="element.slug"
                      :active="selected_tab_index == i"
                      class="w-5 h-5 mr-2 text-gray-400"
                      aria-hidden="true" />
                    {{ element.name }}
                  </div>
                  <!-- <div v-if="selected_tab_index == i || hovered_tab_index == i" class="tab-element absolute z-0 bottom-0 h-2 ml-2 w-[88%]" /> -->
                  <div v-if="selected_tab_index == i" :style="gradient_style" class="tab-element absolute bottom-0 h-1 ml-2 w-[188%]" />
                  <div v-if="hovered_tab_index == i" :style="gradient_style" class="tab-element absolute z-0 bottom-0 h-1 ml-2 w-[88%]" />
                </div>
              </div>
            </div>
            <div class="cursor-pointer" @click="toggleShowMore">
              <div class="relative outline-none ring-0">
                <div
                  class="relative inline-flex font-normal transition duration-300 ease-in-out rounded-sm cursor-pointer sm:text-lg text-common-grey focus:outline-none">
                  <div class="flex items-center h-12 px-8 py-2 bg-white whitespace-nowrap">
                    <LayoutGrid class="w-5 h-5 mr-2 text-gray-400" aria-hidden="true" />
                    {{ show_more_items ? $t("Show less") : $t("Show more") }}
                    <ChevronDown v-if="show_more_items" class="w-5 h-5 text-gray-400 rotate-180" aria-hidden="true" />
                    <ChevronDown v-else class="w-5 h-5 text-gray-400" aria-hidden="true" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mr-3 flex items-center gap-x-2">
            <div class="flex items-center -space-x-5 overflow-hidden">
              <span v-for="user in $store.state.data.users.slice(0, 2)" :key="user.id" class="flex-shrink-0 inline-block has-tooltip">
                <img v-if="user.avatar" class="inline-block rounded-full h-9 w-9 object-cover" :src="user.avatar" alt="">
                <Avatar v-else :first-name="user.first_name" :last-name="user.last_name" class="rounded-full border border-white" />
                <span class="p-1 bg-gray-300 rounded-sm tooltip whitespace-nowrap">
                  <div class="">
                    <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                      {{ user.full_name }}
                    </p>
                  </div>
                </span>
              </span>
              <span
                v-if="$store.state.data.users.length > 2"
                class="flex items-center justify-center font-bold w-8 h-8 border border-white rounded-full bg-light-brand-blue text-sm text-white">
                +{{ $store.state.data.users?.length - 2 }}</span>
            </div>
            <div
              class="flex items-center hover:cursor-pointer border-transparent bg-gradient-to-r from-[#2DA7D7] to-[#3B91DB] px-2 font-bold rounded-lg w-fit-content h-[36px] content-center text-[14px]"
              @click="$emitter.emit(ALL_EMITTERS.INVITE_TEAMMATES)">
              <UserRoundPlus class="mr-2 border-none w-6 h-6 text-white dark:text-gray-500" />
              <span class="text-white whitespace-nowrap">{{ $t("Invite to collaborate") }}</span>
            </div>
          </div>
        </div>
        <div
          v-if="show_more_items"
          ref="burggerMenu"
          class="absolute z-50 bg-white border border-gray-200 rounded-lg shadow-lg top-full min-w-max"
          :style="{ left: children_width - 550 + 'px' }">
          <div
            v-for="(element, i) in hiddenItems"
            :id="$utils.isUUID(element.id) || $route.name == 'WorkspaceItem' ? element.id : element.slug"
            :key="element"
            class="cursor-pointer"
            @click="handleSelectHiddenTab(i)">
            <div
              class="relative outline-none ring-0"
              @mouseenter="hovered_hidden_tab_index = i"
              @mouseleave="hovered_hidden_tab_index = null">
              <div
                :style="[
                  selected_tab_index == visibleItems?.length + i ? `color: ${$store.state.ui_options.theme.selected_item_color}` : ''
                ]"
                :class="[selected_tab_index == visibleItems?.length + i ? 'text-[15px] font-normal' : 'font-normal']"
                class="sm:text-lg transform translate-y-[3px] text-common-grey transition ease-in-out duration-300 rounded-sm relative focus:outline-none inline-flex cursor-pointer">
                <div
                  class="has-tooltip flex items-center h-12 px-8 py-2 bg-white whitespace-nowrap"
                  :class="[i == hiddenItems.length - 1 ? 'pr-10' : '', !i ? 'pl-8' : '']">
                  <component
                    :is="getIcon(element)"
                    :key="element.slug"
                    :active="selected_tab_index == visibleItems?.length + i"
                    class="w-5 h-5 mr-2 text-gray-400"
                    aria-hidden="true" />
                  <span class="relative w-[200px] whitespace-nowrap inline-block truncate text-ellipsis">{{ element.name }}</span>
                  <span class="tooltip flex flex-wrap bg-gray-200 rounded-md ml-7">{{ element.name }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="mx-2">
            <div class="flex my-2 flex-nowrap btn primary-btn" @click="addNewTab">
              <Pencil color="white" class="w-4 h-4 mr-2 text-white" />
              {{ $t("Edit Menu") }}
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-nowrap whitespace-nowrap" />
    </div>
  </div>
</template>

<script>
import LayoutContainer from "@/components/shared/pages/LayoutContainer.vue"
import { LayoutGrid, UserRoundPlus, ChevronDown, Pencil, ArrowLeft } from "lucide-vue-next"
import Avatar from "@/components/shared/Avatar.vue"
import TabsMapIcon from "@/components/shared/icons/TabsMapIcon.vue"
import TabsActivitiesIcon from "@/components/shared/icons/TabsActivitiesIcon.vue"
import TabsChecklistIcon from "@/components/shared/icons/TabsChecklistIcon.vue"
import TabsInsightsIcon from "@/components/shared/icons/TabsInsightsIcon.vue"
import TabsOverviewIcon from "@/components/shared/icons/TabsOverviewIcon.vue"
import TabsContactIcon from "@/components/shared/icons/TabsContactIcon.vue"
import TabsOppIcon from "@/components/shared/icons/TabsOppIcon.vue"
import TabsDepartmentIcon from "@/components/shared/icons/TabsDepartmentIcon.vue"
import TabsCustomObjectIcon from "@/components/shared/icons/TabsCustomObjectIcon.vue"
import TabsCustomPageIcon from "@/components/shared/icons/TabsCustomPageIcon.vue"

import SuccessActivitiesPageIcon from "@/components/shared/icons/workspace-pages-icons/SuccessActivitiesPageIcon.vue"
import ProjectsPageIcon from "@/components/shared/icons/workspace-pages-icons/ProjectsPageIcon.vue"
import SharedGoalsPageIcon from "@/components/shared/icons/workspace-pages-icons/SharedGoalsPageIcon.vue"
import ToDosPageIcon from "@/components/shared/icons/workspace-pages-icons/ToDosPageIcon.vue"
import CustomerOverviewPageIcon from "@/components/shared/icons/workspace-pages-icons/CustomerOverviewPageIcon.vue"
import InsightsPageIcon from "@/components/shared/icons/workspace-pages-icons/InsightsPageIcon.vue"
import ChecklistsPageIcon from "@/components/shared/icons/workspace-pages-icons/ChecklistsPageIcon.vue"
import DocumentsAndFilesPageIcon from "@/components/shared/icons/workspace-pages-icons/DocumentsAndFilesPageIcon.vue"
import HealthAndUsagePageIcon from "@/components/shared/icons/workspace-pages-icons/HealthAndUsagePageIcon.vue"
import MeetYourTeamPageIcon from "@/components/shared/icons/workspace-pages-icons/MeetYourTeamPageIcon.vue"
import CustomPageIcon from "@/components/shared/icons/workspace-pages-icons/CustomPageIcon.vue"
import WelcomePageIcon from "@/components/shared/icons/workspace-pages-icons/WelcomePageIcon.vue"

import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    UserRoundPlus,
    Avatar,
    ChevronDown,
    SuccessActivitiesPageIcon,
    ProjectsPageIcon,
    SharedGoalsPageIcon,
    ToDosPageIcon,
    CustomerOverviewPageIcon,
    InsightsPageIcon,
    ChecklistsPageIcon,
    DocumentsAndFilesPageIcon,
    HealthAndUsagePageIcon,
    MeetYourTeamPageIcon,
    CustomPageIcon,
    WelcomePageIcon,
    LayoutContainer,
    ArrowLeft,
    TabsMapIcon,
    TabsActivitiesIcon,
    TabsChecklistIcon,
    TabsInsightsIcon,
    TabsOverviewIcon,
    LayoutGrid,
    Pencil,
    TabsContactIcon,
    TabsOppIcon,
    TabsDepartmentIcon,
    TabsCustomObjectIcon,
    TabsCustomPageIcon
  },
  inject: ["isModuleVisible", "getPageTabs", "setPageLayout", "deletePageLayout"],
  props: {},
  emits: [],
  data() {
    return {
      ALL_EMITTERS,
      gradient_style: {
        background: `linear-gradient(to right, ${this.$store.state.ui_options.theme.selected_item_color}, #fff)`
      },
      children_width: 0,
      menu_width: null,
      visibleItemCount: 0, // Number of items initially visible
      show_more_items: false,
      hovered_tab_index: null,
      hovered_hidden_tab_index: null,
      visibleItems: [],
      hiddenItems: [],
      static_pages: [
        { slug: "overview", icon: "TabsOverviewIcon" },
        { slug: "insights", icon: "TabsInsightsIcon" },
        { slug: "map", icon: "TabsMapIcon" },
        { slug: "actions", icon: "TabsActivitiesIcon" },
        { slug: "checklists", icon: "TabsChecklistIcon" }
      ],

      visible_pages: []
    }
  },
  computed: {
    workspace_pages() {
      if (this.$store.state.ui.currentWorkspace) {
        return this.$store.state.ui.currentWorkspace?.layout.filter((l) => l.is_visible)
      }
      return []
    },

    selected_tab_index() {
      const is_uuid = this.$utils.isUUID(this.$route.params.page)
      const index = this.visible_pages.findIndex((p) =>
        is_uuid || this.$route.name == "WorkspaceItem" ? p.id == this.$route.params.page : p.slug == this.$route.params.page
      )

      return index
    },
    page_ref_name() {
      if (this.$route.name == "CompanyProfile") {
        return "company_profile"
      }
      if (this.$route.params.object_type == "contact") {
        return "contact_profile"
      }
      return "object_profile"
    }
  },
  watch: {
    visible_pages() {
      if (this.visible_pages.length) {
        this.calculMenuWidth()
      }
    },
    "$store.state.ui_options.theme": {
      deep: true,
      handler() {
        this.gradient_style = {
          background: `linear-gradient(to right, ${this.$store.state.ui_options.theme.selected_item_color}, #fff)`
        }
      }
    }
  },

  activated() {
    this.register_listeners()

    this.getVisiblePages()
    this.hovered_tab_index = null
    this.hovered_hidden_tab_index = null
  },
  created() {
    this.register_listeners()

    this.hovered_tab_index = null
    this.hovered_hidden_tab_index = null
    this.getVisiblePages()
  },

  deactivated() {
    this.unregister_listeners()
  },
  mounted() {
    this.calculMenuWidth()
    document.addEventListener("mouseup", this.handleClickOutside)
  },
  unmounted() {
    document.removeEventListener("mouseup", this.handleClickOutside)
    this.unregister_listeners()
  },
  methods: {
    handleClickOutside(event) {
      if (this.$refs.burggerMenu && !this.$refs.burggerMenu.contains(event.target)) {
        if (this.show_more_items) {
          this.show_more_items = false
        }
        return
      }
    },
    calculMenuWidth() {
      if (this.$refs.parent) {
        this.visibleItems = this.$utils.clone(this.visible_pages)
        setTimeout(() => {
          const parentWidth = this.$refs.parent.offsetWidth - 32
          this.menu_width = parentWidth
          let count = 202 + 231
          this.visibleItemCount = 0

          this.visibleItems.map((item, index) => {
            let child = this.$refs.child.find((ch) => ch.id == item.id)
            if (child) {
              count = count + child.offsetWidth
              if (count < parentWidth) {
                this.visibleItemCount = this.visibleItemCount + 1
                this.children_width = count
              } else if (index == this.visibleItems.length - 1) {
                this.visibleItems = this.visible_pages.slice(0, this.visibleItemCount)
                this.hiddenItems = this.visible_pages.slice(this.visibleItemCount)
              }
            }
          })
        }, 50)
      }
    },
    toggleShowMore() {
      this.show_more_items = !this.show_more_items
    },
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.CONFIRM_DELETE_PAGE_IN_TABS, (page) => {
        this.resetOrDeletePage(page)
      })
      this.$emitter.on(ALL_EMITTERS.PORTFOLIO_UPDATED_IN_TABS, () => {
        if (this.$route.name == "CompanyProfile" || this.$route.name == "ObjectProfile") {
          this.getVisiblePages()
        }
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.PORTFOLIO_UPDATED_IN_TABS)
      this.$emitter.off(ALL_EMITTERS.CONFIRM_DELETE_PAGE_IN_TABS)
    },
    resetOrDeletePage(page) {
      this.deletePageLayout(page).then(() => {
        const desired_property = page.is_static ? "slug" : "id"
        if (this.$route?.params?.page == page[desired_property]) {
          if (page.is_static) {
            this.$emitter.emit(ALL_EMITTERS.FORCE_INIT_LAYOUT)
          } else {
            if (this.$store.state.portfolio.pages_layout[page.page].length) {
              let use_slug_or_id = null
              this.$store.state.portfolio.pages_layout[page.page][0].is_static ? (use_slug_or_id = "slug") : (use_slug_or_id = "id")
              this.$router.push(`${this.$store.state.portfolio.pages_layout[page.page][0][use_slug_or_id]}`)
            } else {
              this.$router.push(`/dashboard`)
            }
          }
        }
      })
    },

    getIcon(element) {
      if (this.$route.name == "WorkspaceItem") {
        let name = element.name
        if (element.id == "to_dos") {
          name = "ToDos"
        }
        if (element.id == "documents_and_files") {
          name = "DocumentsAndFiles"
        }
        if (element.id == "health_and_usage") {
          name = "HealthAndUsage"
        }
        if (element.id == "meet_your_team") {
          name = "MeetYourTeam"
        }
        if (element.id == "success_activities") {
          return SuccessActivitiesPageIcon
        }
        if (element.id == "shared_goals") {
          name = "SharedGoals"
        }
        if (element.id == "customer_overview") {
          name = "CustomerOverview"
        }
        if (this.$utils.isUUID(element.id)) {
          name = "Custom"
        }
        return `${name}PageIcon`
      } else {
        if (element.slug == "opportunity") {
          return TabsOppIcon
        } else if (element.slug == "contact") {
          return TabsContactIcon
        } else if (element.slug == "department") {
          return TabsDepartmentIcon
        } else if (element.icon) {
          return element.icon
        } else if (element.id) {
          return TabsCustomPageIcon
        } else {
          return TabsCustomObjectIcon
        }
      }
    },
    getVisiblePages() {
      if (this.$route.name == "WorkspaceItem") {
        this.visible_pages = this.workspace_pages
      } else {
        let pages_calc = []
        this.$utils
          .clone(this.$store.state.portfolio.pages_layout[this.page_ref_name]?.filter((p) => !p.is_hidden && !p.is_deleted))
          ?.forEach((page) => {
            if (this.static_pages.find((p) => p.slug == page.slug)) {
              pages_calc.push({
                ...page,
                icon: this.static_pages.find((p) => p.slug == page.slug).icon
              })
            } else {
              pages_calc.push(page)
            }
          })
        // change each object element name to object name
        pages_calc = pages_calc.map((page) => {
          // just for object types static pages
          let page_name = page.objectType || page.name.replace("__cs", "__c").toLowerCase()

          if (page.is_static && this.$utils.getObjectTypeByType(page_name, true)) {
            return {
              ...page,
              name:
                this.$utils.getObjectTypeByType(page_name, true).plural_label ||
                this.$utils.makePlural(this.$utils.getObjectTypeByType(page_name, true).label)
            }
          } else {
            return page
          }
        })
        this.visible_pages = pages_calc
      }
    },

    addNewTab() {
      this.$emitter.emit(ALL_EMITTERS.OPEN_PAGE_SETTINGS, { name: this.page_ref_name })
      this.show_more_items = false
    },

    handleSelectTab(e) {
      if (this.$route.name == "WorkspaceItem") {
        this.$router.push(`/workspace/${this.$store.state.ui.currentWorkspace?.short_id}/${this.visible_pages[e].id}`)
      } else {
        const is_uuid = this.$utils.isUUID(this.visible_pages[e].id)
        this.$router.push(`${this.visible_pages[e][is_uuid ? "id" : "slug"]}`)
      }
      this.show_more_items = false
    },
    handleSelectHiddenTab(e) {
      if (this.$route.name == "WorkspaceItem") {
        this.$router.push(`/workspace/${this.$store.state.ui.currentWorkspace?.short_id}/${this.hiddenItems[e].id}`)
      } else {
        const is_uuid = this.$utils.isUUID(this.hiddenItems[e].id)
        this.$router.push(`${this.hiddenItems[e][is_uuid ? "id" : "slug"]}`)
      }
      this.show_more_items = false
    }
  }
}
</script>

<style scoped>
.tab-element::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 90%;
  z-index: -1;
}
</style>
